/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExaBeaconIdDto } from './exaBeaconIdDto';
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface EmployeeV2Dto {
  active?: boolean;
  beacon?: ExaBeaconIdDto;
  beaconLastSeen?: string;
  cost?: number;
  deleted?: boolean;
  email?: string;
  employeeId?: number;
  employeeRole?: string;
  employer?: EnterpriseIdDto;
  firstName?: string;
  id?: number;
  lastLogin?: string;
  lastName?: string;
  password?: string;
  userRole?: string;
  userState?: string;
  username?: string;
}
